import VueRouter, { RouteConfig } from 'vue-router'

const Layout = () => import('../views/Layout.vue')

const Edit = () => import('../views/BroadcastGymnasticsEdit.vue')
const List = () => import('../views/BroadcastGymnasticsList.vue')
const Check = () => import('../views/BroadcastGymnasticsCheck.vue')
const Details = () => import('../views/BroadcastGymnasticsDetails.vue')

const Index = () => import('@/views/GymnasticsList.vue')
const CustomEdit = () => import('@/views/GymnasticsEdit.vue')
const CustomDetail = () => import('@/views/GymnasticsDetail.vue')
const DetailInfo = () => import('@/views/GymnasticsDetailInfo.vue')
const DetailStat = () => import('@/views/GymnasticsDetailStat.vue')

const GymnasticsActivity = () => import('@/views/gymnastics-activity/GymnasticsActivity.vue')

export const editRoute: RouteConfig = {
  path: 'edit',
  name: 'broadcast_gymnastics_edit',
  component: Edit,
  meta: {
    title: '广播操练习',
  },
}

export const listRoute: RouteConfig = {
  path: 'list',
  name: 'broadcast_gymnastics_list',
  component: List,
  props: (route) => ({ listType: +route.query.t || 0 }),
  meta: {
    title: '广播操练习',
    showMenu: true,
  },
}

export const checkRoute: RouteConfig = {
  path: 'check',
  name: 'broadcast_gymnastics_check',
  component: Check,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '广播操练习',
  },
}

export const detailsRoute: RouteConfig = {
  path: 'details',
  name: 'broadcast_gymnastics_details',
  component: Details,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '广播操练习',
  },
}
import broadcastMenuIcon from '@/assets/images/icon_menu_broadcast@2x.png'
import broadcastMenuIconActive from '@/assets/images/icon_menu_broadcast_active@2x.png'

export const customIndexRoute: RouteConfig = {
  path: 'custom',
  name: 'gymnastic_custom_index',
  component: Index,
  meta: { title: '我的自编操', showMenu: true, rolesKey: '广播体操.自编操.查看' },
}

export const customEditRoute: RouteConfig = {
  path: 'custom-edit',
  name: 'gymnastic_custom_edit',
  component: CustomEdit,
  props: (route) => ({ id: route.query.id }),
  meta: { title: '我的自编操', showMenu: false },
}

export const customDetailRoute: RouteConfig = {
  path: 'custom-detail',
  name: 'gymnastic_custom_detail',
  component: CustomDetail,
  meta: { title: '我的自编操', showMenu: false },
  children: [
    {
      path: 'stat',
      name: 'gymnastic_custom_detail_stat',
      component: DetailStat,
      props: (route) => ({ id: route.query.id }),
      meta: { title: '我的自编操' },
    },
    {
      path: 'info',
      name: 'gymnastic_custom_detail_info',
      component: DetailInfo,
      props: (route) => ({ id: route.query.id }),
      meta: { title: '我的自编操' },
    },
  ],
}

export const gymnasticActivityRoute: RouteConfig = {
  path: 'gymnastic-activity',
  name: 'gymnastic_activity',
  component: GymnasticsActivity,
  meta: { title: '智教广播操', showMenu: false },
}

export default [
  {
    path: '/broadcast-gymnastics',
    name: 'broadcast_gymnastics',
    component: Layout,
    meta: {
      title: '广播体操',
      icon: broadcastMenuIcon,
      iconActive: broadcastMenuIconActive,
      showMenu: true,
    },
    children: [
      gymnasticActivityRoute,
      editRoute,
      listRoute,
      checkRoute,
      detailsRoute,
      customIndexRoute,
      customEditRoute,
      customDetailRoute,
    ],
  },
]

export function navigateToGymActivity(router: VueRouter) {
  router.push({ name: gymnasticActivityRoute.name })
}

export function navigateToBroadcastGymnasticsEdit(router: VueRouter) {
  router.push({ name: editRoute.name })
}

export function redirectToBroadcastGymnasticsCheck(router: VueRouter, broadcastGymnasticsId: string) {
  router.replace({ name: checkRoute.name, query: { broadcastGymnasticsId } })
}

export function navigateToBroadcastGymnasticsDetails(router: VueRouter, broadcastGymnasticsId: string) {
  router.push({ name: detailsRoute.name, query: { broadcastGymnasticsId } })
}

export function redirectToBroadcastGymnasticsDetails(router: VueRouter, broadcastGymnasticsId: string) {
  router.replace({ name: detailsRoute.name, query: { broadcastGymnasticsId } })
}
